
import { useNavigate } from 'react-router-dom';

const ProductLineupSection = () => {
  const navigate = useNavigate();

  const handleAutoSteeringClick = () => {
    navigate('/auto-steering');
  };

  const handleWaterManagementClick = () => {
    navigate('/water-management');
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 xl:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16 xl:mb-20">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-5xl 2xl:text-6xl font-bold text-[#2A6041] mb-3 sm:mb-4 md:mb-6">
            こんな「課題」を解決します
          </h2>
          <p className="text-sm sm:text-base md:text-lg lg:text-xl xl:text-2xl text-gray-600 font-medium">
            あなたの農業の悩みに最適なソリューションをご提案
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 xl:gap-10">
          {/* 散布作業の課題 */}
          <div className="bg-white rounded-2xl p-4 sm:p-6 lg:p-8 xl:p-10 shadow-lg hover:shadow-xl transition-shadow flex flex-col h-full">
            <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-4 sm:mb-6 lg:mb-8 mx-auto">
              <i className="ri-flight-land-line text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-[#76B947]"></i>
            </div>
            <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold text-[#2A6041] mb-3 sm:mb-4 lg:mb-6 text-center leading-tight">
              散布作業の負担を<br />劇的に軽くしたい
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl mb-4 sm:mb-6 lg:mb-8 leading-relaxed flex-grow">
              猛暑の中の重労働から解放され、作業時間は1/10以下に。ピンポイント散布も可能で、農薬・肥料コストも大幅に削減します。
            </p>
            <div className="space-y-1 sm:space-y-2 lg:space-y-3 mb-4 sm:mb-6 lg:mb-8">
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>農業ドローン</span>
              </div>
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>センシングドローン</span>
              </div>
            </div>
            <div className="mb-4 sm:mb-6 lg:mb-8">
              <img
                alt="農業ドローン"
                className="w-full h-32 sm:h-40 lg:h-48 xl:h-52 object-cover rounded-lg"
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/4a3f4c37d20b7e567357412a2808122e.webp"
              />
            </div>
            <button
              onClick={() => window.REACT_APP_NAVIGATE('/drones')}
              className="w-full py-2 sm:py-3 lg:py-4 bg-[#76B947] text-white rounded-lg hover:bg-[#2A6041] transition-colors font-bold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl whitespace-nowrap cursor-pointer mt-auto"
            >
              ドローン製品一覧を見る
            </button>
          </div>

          {/* トラクター作業の課題 */}
          <div className="bg-white rounded-2xl p-4 sm:p-6 lg:p-8 xl:p-10 shadow-lg hover:shadow-xl transition-shadow flex flex-col h-full">
            <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-4 sm:mb-6 lg:mb-8 mx-auto">
              <i className="ri-steering-2-line text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-[#76B947]"></i>
            </div>
            <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold text-[#2A6041] mb-3 sm:mb-4 lg:mb-6 text-center leading-tight">
              トラクター作業を<br />正確・簡単にしたい
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl mb-4 sm:mb-6 lg:mb-8 leading-relaxed flex-grow">
              ハンドル操作から解放され、誰でも熟練者の精度を実現。夜間作業も可能になり、作業時間を有効活用できます。
            </p>
            <div className="space-y-1 sm:space-y-2 lg:space-y-3 mb-4 sm:mb-6 lg:mb-8">
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>農機自動操舵システム</span>
              </div>
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>RTKレベリングシステム</span>
              </div>
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>精密スプレーシステム</span>
              </div>
            </div>
            <div className="mb-4 sm:mb-6 lg:mb-8">
              <img
                alt="自動操舵システム"
                className="w-full h-32 sm:h-40 lg:h-48 xl:h-52 object-cover rounded-lg"
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/7d3ec6cfdabbdac1031815e58f241a4b.webp"
              />
            </div>
            <button
              className="w-full py-2 sm:py-3 lg:py-4 bg-[#76B947] text-white rounded-lg hover:bg-[#2A6041] transition-colors font-bold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl whitespace-nowrap cursor-pointer mt-auto"
              onClick={handleAutoSteeringClick}
            >
              自動操舵システム一覧を見る
            </button>
          </div>

          {/* 水管理の課題 */}
          <div className="bg-white rounded-2xl p-4 sm:p-6 lg:p-8 xl:p-10 shadow-lg hover:shadow-xl transition-shadow flex flex-col h-full">
            <div className="w-12 h-12 sm:w-16 sm:h-16 lg:w-20 lg:h-20 xl:w-24 xl:h-24 bg-[#76B947]/10 rounded-full flex items-center justify-center mb-4 sm:mb-6 lg:mb-8 mx-auto">
              <i className="ri-drop-line text-xl sm:text-2xl lg:text-3xl xl:text-4xl text-[#76B947]"></i>
            </div>
            <h3 className="text-base sm:text-lg md:text-xl lg:text-2xl xl:text-3xl 2xl:text-4xl font-bold text-[#2A6041] mb-3 sm:mb-4 lg:mb-6 text-center leading-tight">
              水管理作業を<br />効率化したい
            </h3>
            <p className="text-gray-600 text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl mb-4 sm:mb-6 lg:mb-8 leading-relaxed flex-grow">
              田んぼの見回りから解放され、スマホで水位確認・給水操作が可能。労力削減と精密な水管理を同時に実現します。
            </p>
            <div className="space-y-1 sm:space-y-2 lg:space-y-3 mb-4 sm:mb-6 lg:mb-8">
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>水田用水管理システム</span>
              </div>
              <div className="flex items-center text-xs sm:text-sm md:text-base lg:text-lg text-[#76B947] font-medium">
                <i className="ri-arrow-right-line mr-2 text-sm sm:text-base"></i>
                <span>ハウス用（環境モニタリング）</span>
              </div>
            </div>
            <div className="mb-4 sm:mb-6 lg:mb-8">
              <img
                alt="水管理システム"
                className="w-full h-32 sm:h-40 lg:h-48 xl:h-52 object-cover rounded-lg"
                src="https://static.readdy.ai/image/b1b0be4a533f8dd52f529875d332f87d/41b1631f2755a2c34f640bfba0f970ed.webp"
              />
            </div>
            <button
              onClick={handleWaterManagementClick}
              className="w-full py-2 sm:py-3 lg:py-4 bg-[#76B947] text-white rounded-lg hover:bg-[#2A6041] transition-colors font-bold text-xs sm:text-sm md:text-base lg:text-lg xl:text-xl whitespace-nowrap cursor-pointer mt-auto"
            >
              水管理システム一覧を見る
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductLineupSection;
